import { Estado } from './Estado';

export class Cidade {
    id = 0;
    nome = '';
    estado = new Estado();
}